import { ChangeDetectorRef, Component, inject, Inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogContent, MatDialogRef } from '@angular/material/dialog';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatError } from '@angular/material/input';
import { BmiDialogModel } from '../../../interfaces/dialogs/bmi-dialog.model';

@Component({
  selector: 'app-bmi-dialog',
  standalone: true,
  imports: [MatButton, MatDialogContent, TranslatePipe, ReactiveFormsModule, MatError],
  templateUrl: './bmi-dialog.component.html',
  styleUrl: './bmi-dialog.component.scss'
})
export class BmiDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<BmiDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: BmiDialogModel,
    private fb: FormBuilder,
    private cdr: ChangeDetectorRef,
  ) { }
  translateService: TranslateService = inject(TranslateService);
  form!: FormGroup;
  height = 0;
  weight = 0;
  bmi = '--';


  ngOnInit(): void {
    console.log('open duo, ', this.data);
    this.form = this.fb.group({
      height: [null, [
        Validators.required,
        Validators.min(1),
        Validators.max(300),
      ]], // cm
      weight: [null, [
        Validators.required,
        Validators.min(1),
        Validators.max(300),
      ]]  // kg
    });
  }



  onNumberInput(event: Event, maxLength: number, controlName: string) {
    const input = event.target as HTMLInputElement;
    let value = input.value;

    // 限制長度
    if (value.length > maxLength) {
      value = value.slice(0, maxLength);
    }

    // 更新 FormControl
    this.form.get(controlName)?.setValue(value, { emitEvent: false });

    // 同步 input value
    input.value = value;
    const innerBmi = this.calculateBmi(this.form.value.height, this.form.value.weight);
    this.bmi = isNaN(innerBmi) ? '--' : innerBmi.toString();
    this.cdr.detectChanges();
  }

  leftButtonAction() {
    this.dialogRef.close('close')
  }

  rightButtonAction() {
    if (this.form.valid) {
      const { height, weight } = this.form.value;
      const bmi = this.calculateBmi(height, weight);
      this.dialogRef.close({
        height,
        weight,
        bmi
      });
    } else {
      this.dialogRef.close({
        height: 0,
        weight: 0,
        bmi: 0,
      })
    }
  }

  private calculateBmi(height: number, weight: number): number {
    if (!height || !weight || isNaN(height) || isNaN(weight) || height > 300 || weight > 300) {
      return NaN;
    }
    return Math.round((weight / ((height / 100) * (height / 100))) * 100) / 100;
  }

}
